<template>
    <div class="pt-24">
        <div v-for="invite in invites">
            {{ invite.options.email }} |
            {{ invite.options.status }} |
            <Link v-if="invite.options.status != 'accepted'" as="button" method="delete" :href="'/invites/' + invite.token">×</Link>
        </div>
        <Link href="/invites/create">+</Link>
    </div>
</template>

<script>
    import Layout from '@/Shared/Layout'

    export default {
        props: {
            invites: Object,
        },
        layout: Layout,
    }
</script>
